import React from 'react';

/**
 * LA PÍLDORA DE UN MARCADOR DE CHAT — una sola, para los marcadores que haya.
 *
 * ───────────────────────────────────────────────────────────────────────────────
 * QUÉ UNIFICA Y QUÉ NO (23-sep-2026)
 * ───────────────────────────────────────────────────────────────────────────────
 * Unifica **el render**: el bloque de estilos en línea que pintaba la marca de venta
 * en la lista, copiado tal cual, era lo que iba a duplicarse por cada marcador nuevo.
 * Con dos marcadores ya son dos copias; con el de traspaso serían tres, y la tercera
 * es siempre la que se queda con el `borderRadius` distinto.
 *
 * **NO unifica el estado.** Venta, agenda y traspaso se parecen sólo aquí abajo:
 *
 *   · la venta vive en el chat porque su hecho está en Shopify, fuera de Firestore
 *   · la agenda se CALCULA de `{tenant}/bookings`, que es nuestro
 *   · el traspaso no existe todavía y, cuando exista, no tendrá otra casa que el chat
 *
 * Fundirlos en un mapa `marcadores: {}` sería inventar un cuarto vocabulario para
 * tres hechos con tres fuentes de verdad distintas, una de las cuales no debe
 * persistirse. Así que cada uno conserva su función pura y comparten la píldora.
 *
 * @param {string} icono   - el emoji, ya decidido por el llamante
 * @param {string} texto   - la parte en negrita
 * @param {string} [sufijo]- lo secundario, en gris (p. ej. «· 3 compras»)
 * @param {string} fondo   - color de fondo
 * @param {string} color   - color del texto
 * @param {string} [titulo]- `title` del elemento, para el detalle largo
 */
export default function MarcaDeChat({ icono, texto, sufijo, fondo, color, titulo }) {
  return (
    <div
      title={titulo || undefined}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: '0.4rem',
        marginBottom: '0.6rem', padding: '0.25rem 0.6rem', borderRadius: '999px',
        backgroundColor: fondo,
        color,
        fontSize: '12px', fontWeight: 600,
      }}
    >
      {icono} {texto}
      {sufijo && (
        <span style={{ fontWeight: 500, opacity: 0.85 }}>{sufijo}</span>
      )}
    </div>
  );
}
